var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#E7E6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7778 27.1111H28M21.7778 12.8889H28H21.7778ZM21.7778 17.3333H28H21.7778ZM21.7778 22.6667H28H21.7778ZM13 18.2222H17.2222C17.7745 18.2222 18.2222 17.7745 18.2222 17.2222V13C18.2222 12.4477 17.7745 12 17.2222 12H13C12.4477 12 12 12.4477 12 13V17.2222C12 17.7745 12.4477 18.2222 13 18.2222ZM13 28H17.2222C17.7745 28 18.2222 27.5523 18.2222 27V22.7778C18.2222 22.2255 17.7745 21.7778 17.2222 21.7778H13C12.4477 21.7778 12 22.2255 12 22.7778V27C12 27.5523 12.4477 28 13 28Z",
    stroke: "#605BFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonList);
export default __webpack_public_path__ + "static/media/button-list.3e376aaaa5d8d9b60b56c22a8796a9a8.svg";
export { ForwardRef as ReactComponent };